/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'runed',
    quality: 0.5,
    learning: 2,
    magicalGravity: 0.3
}